import { Children } from 'react';

const Show=props=>{let whenComponents=null;let otherwise=null;Children.forEach(props.children,child=>{if(child.props.isTrue===undefined){otherwise=child;}else if(child.props.isTrue){if(!whenComponents){whenComponents=[];}whenComponents.push(child);}});return whenComponents||otherwise};Show.When=({isTrue,children})=>isTrue&&children?children:null;Show.Else=({render,children})=>render||children||null;

export { Show };
//# sourceMappingURL=Show.js.map
